import { Graph } from '@antv/x6'
import dagre from 'dagre'
import Count from '../../components/strategicMap/Count.vue'
import zcardlists from '../../components/strategicMap/zbCardLists.vue'
import graphcanves from '../../components/strategicMap/graphCanves.vue'

export function initGraphOptions ({ graph }) {
  const GRAPH = graph
  //   { source, target, direction = ['L', 'R'] }
  function setConnectEdge (source, target) {
    // checkNodeEdgeCount(source, direction[1])
    // let { x: sx, y: sy } = source.getBBox()
    // let { x: tx, y: ty } = target.getBBox()
    GRAPH.addEdge({
      shape: 'org-edge',
      source: { cell: source },
      target: { cell: target },
      //   source: { cell: source, port: direction[0] },
      //   target: { cell: target, port: direction[1] },
      attrs: {
        line: {
          stroke: '#A2B1C3',
          strokeWidth: 2
        }
      }
      //   vertices: [
      //     { x: sx + 20, y: sy + 20 },
      //     { x: tx + 20, y: ty + 20 }
      //   ],
    //   router: {
    //     name: 'orth',
    //     args: {}
    //   },
    //   zIndex: -1
    })
  }
  function defaultNode (options) {
    return GRAPH.addNode({
    //   x: 340,
    //   y: 50,
      width: 200,
      height: 40,
      attrs: {
        body: {
          stroke: '#5F95FF',
          fill: '#EFF4FF',
          strokeWidth: 1
        }
      },
      ports: {
        groups: {
          bottom: {
            position: 'bottom',
            attrs: {
              circle: {
                stroke: '#5F95FF',
                strokeWidth: 1,
                r: 4,
                magnet: true,
                style: {
                  visibility: 'hidden'
                }
              }
            }
          },
          top: {
            position: 'top',
            attrs: {
              circle: {
                stroke: '#5F95FF',
                strokeWidth: 1,
                r: 4,
                magnet: true,
                style: {
                  visibility: 'hidden'
                }
              }
            }
          },
          left: {
            position: 'left',
            attrs: {
              circle: {
                stroke: '#5F95FF',
                strokeWidth: 1,
                r: 4,
                magnet: true,
                style: {
                  visibility: 'hidden'
                }
              }
            }
          },
          right: {
            position: 'right',
            attrs: {
              circle: {
                stroke: '#5F95FF',
                strokeWidth: 1,
                r: 4,
                magnet: true,
                style: {
                  visibility: 'hidden'
                }
              }
            }
          }
        },
        items: [
          {
            id: 'T',
            group: 'top',
            tip: 'port-1-tip'
          },
          {
            id: 'B',
            group: 'bottom',
            tip: 'port-1-tip'
          },
          {
            id: 'L',
            group: 'left',
            tip: 'port-1-tip'
          },
          {
            id: 'R',
            group: 'right',
            tip: 'port-1-tip'
          }
        ]
      },
      ...options
    })
  }

  function graphRegisterEdge () {
    // 自定义边
    Graph.registerEdge(
      'org-edge',
      {
        zIndex: -1,
        attrs: {
          line: {
            strokeWidth: 2,
            stroke: '#A2B1C3',
            sourceMarker: null,
            targetMarker: null
          }
        }
      },
      true
    )
  }
  function graphRegisterNode () {
    // 自定义节点
    Graph.registerNode(
      'org-node',
      {
        width: 260,
        height: 88,
        markup: [
          {
            tagName: 'rect',
            attrs: {
              class: 'card'
            }
          },
          {
            tagName: 'image',
            attrs: {
              class: 'image'
            }
          },
          {
            tagName: 'text',
            attrs: {
              class: 'rank'
            }
          },
          {
            tagName: 'text',
            attrs: {
              class: 'name'
            }
          },
          {
            tagName: 'g',
            attrs: {
              class: 'btn add'
            },
            children: [
              {
                tagName: 'circle',
                attrs: {
                  class: 'add'
                }
              },
              {
                tagName: 'text',
                attrs: {
                  class: 'add'
                }
              }
            ]
          },
          {
            tagName: 'g',
            attrs: {
              class: 'btn del'
            },
            children: [
              {
                tagName: 'circle',
                attrs: {
                  class: 'del'
                }
              },
              {
                tagName: 'text',
                attrs: {
                  class: 'del'
                }
              }
            ]
          }
        ],
        attrs: {
          '.card': {
            rx: 10,
            ry: 10,
            refWidth: '100%',
            refHeight: '100%',
            fill: '#5F95FF',
            stroke: '#5F95FF',
            strokeWidth: 1,
            pointerEvents: 'visiblePainted'
          },
          '.image': {
            x: 16,
            y: 16,
            width: 56,
            height: 56,
            opacity: 0.7
          },
          '.rank': {
            refX: 0.95,
            refY: 0.5,
            fill: '#fff',
            fontFamily: 'Courier New',
            fontSize: 13,
            textAnchor: 'end',
            textVerticalAnchor: 'middle'
          },
          '.name': {
            refX: 0.95,
            refY: 0.7,
            fill: '#fff',
            fontFamily: 'Arial',
            fontSize: 14,
            fontWeight: '600',
            textAnchor: 'end'
          },
          '.btn.add': {
            refDx: -16,
            refY: 16,
            event: 'node:add'
          },
          '.btn.del': {
            refDx: -44,
            refY: 16,
            event: 'node:delete'
          },
          '.btn > circle': {
            r: 10,
            fill: 'transparent',
            stroke: '#fff',
            strokeWidth: 1
          },
          '.btn.add > text': {
            fontSize: 20,
            fontWeight: 800,
            fill: '#fff',
            x: -5.5,
            y: 7,
            fontFamily: 'Times New Roman',
            text: '+'
          },
          '.btn.del > text': {
            fontSize: 28,
            fontWeight: 500,
            fill: '#fff',
            x: -4.5,
            y: 6,
            fontFamily: 'Times New Roman',
            text: '-'
          }
        }
      },
      true
    )
  }
  function graphRegisterComponents () {
    Graph.registerVueComponent(
      'count',
      {
        template: `<Count />`,
        components: {
          Count
        }
      },
      true
    )
    Graph.registerVueComponent(
      'zcardLists',
      {
        template: `<zcardlists />`,
        components: {
          zcardlists
        }
      },
      true
    )
    Graph.registerVueComponent(
      'graphcanves',
      {
        template: `<graphcanves />`,
        components: {
          graphcanves
        }
      },
      true
    )
  }
  // 布局方向
  const dir = 'TB' // LR RL TB BT
  // 自动布局
  function layout (nodesLists, edgesLists) {
    console.log(1)
    const nodes = nodesLists
    const edges = edgesLists
    // const nodes = graph.getNodes()
    // const edges = graph.getEdges()
    const g = new dagre.graphlib.Graph()
    g.setGraph({ rankdir: dir, nodesep: 16, ranksep: 16 })
    g.setDefaultEdgeLabel(() => ({}))

    const width = 800
    const height = 240
    nodes.forEach((node) => {
      g.setNode(node.id, { width, height })
    })

    edges.forEach((edge) => {
      const source = edge.getSource()
      const target = edge.getTarget()
      g.setEdge(source.cell, target.cell)
    })

    dagre.layout(g)

    graph.freeze()

    g.nodes().forEach((id) => {
      const node = graph.getCell(id)
      if (node) {
        const pos = g.node(id)
        node.position(pos.x, pos.y)
      }
    })

    edges.forEach((edge) => {
      const source = edge.getSourceNode()
      const target = edge.getTargetNode()
      const sourceBBox = source.getBBox()
      const targetBBox = target.getBBox()

      console.log(sourceBBox, targetBBox)

      if ((dir === 'LR' || dir === 'RL') && sourceBBox.y !== targetBBox.y) {
        const gap =
          dir === 'LR'
            ? targetBBox.x - sourceBBox.x - sourceBBox.width
            : -sourceBBox.x + targetBBox.x + targetBBox.width
        const fix = dir === 'LR' ? sourceBBox.width : 0
        const x = sourceBBox.x + fix + gap / 2
        edge.setVertices([
          { x, y: sourceBBox.center.y },
          { x, y: targetBBox.center.y }
        ])
      } else if (
        (dir === 'TB' || dir === 'BT') &&
        sourceBBox.x !== targetBBox.x
      ) {
        const gap =
          dir === 'TB'
            ? targetBBox.y - sourceBBox.y - sourceBBox.height
            : -sourceBBox.y + targetBBox.y + targetBBox.height
        const fix = dir === 'TB' ? sourceBBox.height : 0
        const y = sourceBBox.y + fix + gap / 2
        edge.setVertices([
          { x: sourceBBox.center.x, y: y },
          { x: targetBBox.center.x, y: y }
        ])
      } else {
        edge.setVertices([])
      }
    })

    graph.unfreeze()
  }

  function setNodeOrgChildNode (source, target) {
    let { x, y, width } = source.getBBox()
    target.position(x + width + 30, y)
    return createEdge(source, target)
  }

  function RefreshCavas (nodes, edges) {

  }
  function createNode (rank, name, image) {
    return graph.createNode({
      // shape: 'org-node',
      // attrs: {
      //   '.rank': {
      //     text: Dom.breakText(rank, { width: 160, height: 45 })
      //   },
      //   '.name': {
      //     text: Dom.breakText(name, { width: 160, height: 45 })
      //   }
      // }
      width: 300,
      height: 200,
      shape: 'vue-shape',
      component: 'count',
      data: {
        num: 0,
        title: rank,
        nodeType: 1
      }
    })
  }
  function createEdge (source, target) {
    return graph.createEdge({
      shape: 'org-edge',
      source: { cell: source.id },
      target: { cell: target.id }
    })
  }
  return { setNodeOrgChildNode, graphRegisterNode, layout, setConnectEdge, defaultNode, graphRegisterEdge, graphRegisterComponents, createNode, createEdge }
}
